import { createStandardAction, createAsyncAction } from 'typesafe-actions'
import {
  GetCheckListReq,
  GetCheckListByIdReq,
  DeleteCheckListReq,
  CreateCheckListReq,
  UpdateCheckListReq,
  CheckListItem,
  CheckListDetail,
} from './types'
import { GetApiResponse, List } from 'features/types/common'
import { ProjectCheckListResp } from 'features/types/checklist'

export const getCheckListAction = createAsyncAction(
  'checklist/auditRoad/GET_CHECK_LIST_REQ',
  'checklist/auditRoad/GET_CHECK_LIST_RESP',
  'checklist/auditRoad/GET_CHECK_LIST_FAIL'
)<GetCheckListReq, GetApiResponse<List<CheckListItem>>, Error>()

export const getCheckListByIdAction = createAsyncAction(
  'checklist/auditRoad/GET_CHECK_ID_REQ',
  'checklist/auditRoad/GET_CHECK_ID_RESP',
  'checklist/auditRoad/GET_CHECK_ID_FAIL'
)<GetCheckListByIdReq, GetApiResponse<CheckListDetail>, any>()

export const createCheckListAction = createAsyncAction(
  'checklist/auditRoad/CREATE_CHECK_ID_REQ',
  'checklist/auditRoad/CREATE_CHECK_ID_RESP',
  'checklist/auditRoad/CREATE_CHECK_ID_FAIL'
)<CreateCheckListReq, any, any>()

export const updateCheckListAction = createAsyncAction(
  'checklist/auditRoad/UPDATE_CHECK_ID_REQ',
  'checklist/auditRoad/UPDATE_CHECK_ID_RESP',
  'checklist/auditRoad/UPDATE_CHECK_ID_FAIL'
)<UpdateCheckListReq, any, any>()

export const deleteCheckListAction = createAsyncAction(
  'checklist/auditRoad/DELETE_CHECK_ID_REQ',
  'checklist/auditRoad/DELETE_CHECK_ID_RESP',
  'checklist/auditRoad/DELETE_CHECK_ID_FAIL'
)<DeleteCheckListReq, any, any>()

export const clearCheckListDetail = createStandardAction(
  'checklist/auditRoad/CLEAR_CHECK_LIST_DETAIL'
)<void>()

export const updateCheckListDetail = createStandardAction(
  'checklist/auditRoad/UPDATE_CHECKLIST_DETAIL'
)<CheckListDetail>()

export const getProjectAction = createAsyncAction(
  'checklist/auditRoad/GET_PROJECT_REQ',
  'checklist/auditRoad/GET_PROJECT_RESP',
  'checklist/auditRoad/GET_PROJECT_FAIL'
)<any, ProjectCheckListResp, any>()
